module.exports = __webpack_public_path__ + "static/media/network.67495e3f.svg";